<template>
  <vue-modal id="sumUpPaymentModal"
             :width="$store.getters.isMobileDevice ? '100%' : '50%'"
             classes="vue-modal-container"
             height="auto"
             name="sum-up-payment-modal"
             scrollable
             @closed="modalClosed"
             @opened="modalOpened"
             @before-open="beforeModalOpen">
    <div class="header">
      <h3>{{ trans.header }}</h3>
      <button class="close-modal"
              @click="$modal.hide('sum-up-payment-modal')">
        <i class="close icon"/>
      </button>
      <div>
        <div id="sumup-card"></div>
      </div>
    </div>
    <div class="content">
      <i>{{ trans.footer }}</i>
    </div>
  </vue-modal>
</template>

<script>
import {mapState} from 'vuex';
import config from '@/config';
import utils from '@/utils';
import notify from '../../notify';

export default {
  data () {
    return {
      serverDomain: config.SERVER_DOMAIN,
      transactionId: null,
      checkoutID: null,
      sumUpObject: null,
      isFinished: false,
    }
  },
  methods: {
    beforeModalOpen (event) {
      this.transactionId = event.params.data.transactionId;
      this.checkoutID = event.params.data.checkoutID;
      this.isFinished = false;
      console.log('BEJÖVŐ', this.transactionId, this.checkoutID);
    },

    modalOpened () {

      // eslint-disable-next-line
      this.sumUpObject = SumUpCard.mount({
        id: 'sumup-card',
        checkoutId: this.checkoutID,
        onResponse: (respType, respBody) => {
          console.log('respType', respType);
          console.log('respBody', respBody);
          // https://developer.sumup.com/online-payments/tools/card-widget
          // lehetséges: sent | invalid | auth-screen | error | success
          //   figyelem! a success még nem sikeres fizetést jelent!!
          if (['error', 'success'].indexOf(respType) >= 0) {
            this.$http({
              url: this.serverDomain + '/api/pay/sumup-card-pay-ready',
              method: 'POST',
              params: {
                ...this.$store.getters.getAuthParams,
              },
              body: {
                data: {
                  ...respBody,
                  responseType: respType,
                  transactionId: this.transactionId,
                },
              },
            }).then((resp) => {
                console.log('---- szerver-----', resp);
                this.isFinished = true;
                this.$modal.hide('sum-up-payment-modal');
                if (resp.body?.msgType === 'success' && resp.body.msg)
                  notify.success(resp.body.msg);
                else
                  notify.error(resp.body?.msg || 'HIBA');
              },
              (error) => {
                this.isFinished = true;
                this.$modal.hide('sum-up-payment-modal');
                utils.httpError(error);
              })
          }
        },
      });
    },
    modalClosed () {
      if (this.sumUpObject) {
        this.sumUpObject.unmount()
      }
      if (!this.isFinished) {
        this.$http({
          url: this.serverDomain + '/api/pay/sumup-card-pay-ready',
          method: 'POST',
          params: {
            ...this.$store.getters.getAuthParams,
          },
          body: {
            data: {
              responseType: 'closed',
              transactionId: this.transactionId,
            },
          },
        }).then((resp) => {
            console.log('---- szerver on close-----', resp);
            if (resp.body?.msgType === 'success' && resp.body.msg)
              notify.success(resp.body.msg);
            else
              notify.error(resp.body?.msg || 'HIBA');
          },
          (error) => {
            utils.httpError(error);
          })
      }
    },
    testFunction () {
      console.log('testFunction')
    },
  },
  computed: {
    ...mapState({
      trans: state => state.trans.sumUpPaymentModal,
    }),
  },
}
</script>
<style scoped>
#sumUpPaymentModal .content {
  text-align: center;
}
</style>

